(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('professional-area-group', {
            parent: 'entity',
            url: '/professional-area-group',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalAreaGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area-group/professional-area-groups.html',
                    controller: 'ProfessionalAreaGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalAreaGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('professional-area-group-detail', {
            parent: 'professional-area-group',
            url: '/professional-area-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalAreaGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-detail.html',
                    controller: 'ProfessionalAreaGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalAreaGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfessionalAreaGroup', function($stateParams, ProfessionalAreaGroup) {
                    return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'professional-area-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('professional-area-group-detail.edit', {
            parent: 'professional-area-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-dialog.html',
                    controller: 'ProfessionalAreaGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalAreaGroup', function(ProfessionalAreaGroup) {
                            return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area-group.new', {
            parent: 'professional-area-group',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-dialog.html',
                    controller: 'ProfessionalAreaGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                groupId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('professional-area-group', null, { reload: 'professional-area-group' });
                }, function() {
                    $state.go('professional-area-group');
                });
            }]
        })
        .state('professional-area-group.edit', {
            parent: 'professional-area-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-dialog.html',
                    controller: 'ProfessionalAreaGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalAreaGroup', function(ProfessionalAreaGroup) {
                            return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area-group', null, { reload: 'professional-area-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area-group.delete', {
            parent: 'professional-area-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-delete-dialog.html',
                    controller: 'ProfessionalAreaGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfessionalAreaGroup', function(ProfessionalAreaGroup) {
                            return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area-group', null, { reload: 'professional-area-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
